
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import DimssaButton, { ButtonState } from "@/components/shared/dimssa-button.vue";
import EarTag from "@/components/shared/EarTag.vue";
import lodash from "lodash";
import * as Models from "@gigalot/data-models";
import { changeTrackingComponentFragment } from "@/helpers/gql";
import { getTagColour, tagId, visualNumber } from "@/helpers/visual-tag";
import * as sgtinH from "@/helpers/sgtin";
import { getItemFromServer } from "@/helpers/get-item-from-server";
import { listAilment, listDispatchToAbattoirBatch, listDispatchToSiteBatch } from "@/helpers/graphql-list-items";
import { decimal } from "vuelidate/lib/validators";
import { validationMixin } from "vuelidate";
import { listAnimal } from "@/helpers/graphql-list-items";

@Component({
  components: {
    DimssaButton,
    EarTag,
  },
  mixins: [validationMixin],
  validations: {
    mass: { decimal, positive: (val) => val > 0 },
    cost: { decimal },
  },
})
export default class Mortality extends Vue {
  //selectedAnimal: any = "";
  selectedKraalId: any = "";

  tagColour: string = "green";

  changed: boolean = false;

  animalListItemSearch: string = "";

  diedInTransit: boolean = false;
  dispatchDestinationType: "abattoir" | "site" = "abattoir";
  selectedDispatchBatch: any | "" = ""; //head up this is a list item not the batch itself
  selectedDispatchBatchCustomFeeder?: Models.CustomFeeder;
  dispatchBatches: any[] = [];
  lockedDetails: boolean = false;

  @Watch("diedInTransit")
  async onDiedInTransitChanged(val: any) {
    //console.log("onDiedInTransitChanged", this.diedInTransit);

    this.$store.commit("updateUserLocationField", { path: "mortality.diedInTransit", value: this.diedInTransit });

    this.animalListItems = [];
    this.selectedAnimalListItem = "";

    if (!this.diedInTransit) {
      this.dispatchDestinationType = "abattoir";
      this.selectedDispatchBatch = "";
      this.selectedDispatchBatchCustomFeeder = undefined;
      this.dispatchBatches = [];
      this.refreshAnimalListItemsButtonState = "disabled";
      // clear selected tag  (already done above when selectedAnimalListItem is blanked)
      return;
    }

    await this.getDispatchBatches();
  }

  @Watch("dispatchDestinationType")
  async onDispatchDestinationTypeChanged(val: any) {
    this.$store.commit("updateUserLocationField", { path: "mortality.dispatchDestinationType", value: this.dispatchDestinationType });

    this.animalListItems = [];
    //console.log("onDispatchDestinationTypeChanged", this.dispatchDestinationType);
    if (!this.diedInTransit) return;

    await this.getDispatchBatches();
    this.selectedAnimalListItem = "";
  }

  @Watch("selectedDispatchBatch")
  async onSelectedDispatchBatchChanged(val: any) {
    console.log(this.selectedDispatchBatch);

    if (this.selectedDispatchBatch !== "") {
      this.$store.commit("updateUserLocationField", { path: "mortality.dispatchBatchGuid", value: this.selectedDispatchBatch.guid });
    } else {
      this.$store.commit("updateUserLocationField", { path: "mortality.dispatchBatchGuid", value: undefined });
    }

    if (this.selectedDispatchBatch !== "") {
      let typename: string = "";
      if (this.dispatchDestinationType === "abattoir") {
        typename = "DispatchToAbattoirBatch";
      } else if (this.dispatchDestinationType === "site") {
        typename = "DispatchToSiteBatch";
      }
      const dispatchBatch: Models.DispatchToAbattoirBatch | Models.DispatchToSiteBatch = await getItemFromServer(typename, this.selectedDispatchBatch.guid);
      if (dispatchBatch && dispatchBatch.transport && dispatchBatch.transport.length > 0) {
        this.selectedDispatchBatchCustomFeeder = dispatchBatch.transport[0].customFeeder;
      }
      //console.log("CUSTOMFEEDER", dispatchBatch.transport[0].customFeeder);
    }

    this.animalListItems = [];

    await this.refreshAnimalListItems();
  }

  dispatchBatchMonthsAgo: number = 2;

  @Watch("dispatchBatchMonthsAgo")
  onChangeDispatchBatchMonthsAgo(val: number) {
    const isNumber = (val: any): boolean => typeof val === "number" && !isNaN(val);
    if (!isNumber(val)) return;
    this.getDispatchBatches();
  }

  async getDispatchBatches() {
    function getEpochMillisMonthsAgo(months: number): number {
      const now = new Date();
      now.setMonth(now.getMonth() - months);
      return now.getTime();
    }

    if (this.dispatchDestinationType === "abattoir") {
      this.dispatchBatches =
        (
          await listDispatchToAbattoirBatch(false, {
            itemsPerPage: 10 * 1000,
            page: 1,
            search: "",
            sortBy: [],
            sortDesc: [],
            timeFrom: getEpochMillisMonthsAgo(this.dispatchBatchMonthsAgo),
          })
        )?.items ?? [];
    } else if (this.dispatchDestinationType === "site") {
      this.dispatchBatches =
        (
          await listDispatchToSiteBatch(false, {
            itemsPerPage: 10 * 1000,
            page: 1,
            search: "",
            sortBy: [],
            sortDesc: [],
            timeFrom: getEpochMillisMonthsAgo(this.dispatchBatchMonthsAgo),
          })
        )?.items ?? [];
    }
  }

  NUM_CHARS = 3; //number characters that need to be entered before tag list is populated

  @Watch("animalListItemSearch")
  onAnimalListItemSearchChanged(val: any) {
    console.log("onAnimalListItemSearchChanged", this.animalListItemSearch);

    if (this.animalListItemSearch?.length === this.NUM_CHARS) {
      this.refreshAnimalListItems();
    } else if (this.animalListItemSearch?.length < this.NUM_CHARS) {
      this.refreshAnimalListItemsButtonState = "disabled";
      this.animalListItems = [];
    }
  }

  @Watch("changed")
  onChangeChanged(val: any) {
    this.$store.commit("navFuncs", { save: this.save, back: this.back });
  }

  async created() {
    this.$store.commit("navFuncs", {
      save: undefined,
      back: () => {
        this.$store.commit("updateUserLocationField", { path: "mortality", value: {} });
        this.$router.push({ path: "list/mortalities" });
      },
    });
    //this.ailments = (await this.$store.dispatch("data/get", { objectStore: "Ailment" })) as Models.Ailment[];
    this.selectedAilments = this.mortality.ailments;
    if (this.mortality.time !== undefined && this.mortality.time !== null) {
      this.dateString = this.moment(this.mortality.time).format("YYYY-MM-DD");
    }
    this.massChange(this.mortality.mass);
    this.costChange(this.mortality.cost);
    if (!this.mortality.notes.length) this.mortality.notes = [""];
    else this.notes = this.mortality.notes[0];

    // this.animals = await this.$store.dispatch("data/get", { objectStore: "Animal" });
    // this.animals = this.animals.map((a: any) => Object.assign(a, { visualSgtin: sgtinH.visual(a.sgtin) }));
    // if (this.mortality.sgtin) this.animals = [{ sgtin: this.mortality.sgtin, visualSgtin: sgtinH.visual(this.mortality.sgtin) }, ...this.animals];

    //this.kraalIds = ((await this.$store.dispatch("data/get", { objectStore: "Kraal" })) as Models.Kraal[]).map(k => k.kraalId);
    this.getKraals();

    this.selectedKraalId = this.mortality.sourceKraalId ?? "";

    this.determineTagColour();

    for (const selectedAilment of this.selectedAilments) {
      if (selectedAilment) {
        //this.selectedAilmentListItem = { guid: selectedAilment.guid, text: selectedAilment.ailment ?? "" };
        this.selectedAilmentsListItems.push({ guid: selectedAilment.guid, text: selectedAilment.ailment ?? "" });
        this.getSelectedAilmentsButtonState = "success";
      }
    }
    this.getAilmentListItems();

    //await this.refreshAnimalListItems();

    //this.selectedAnimal = this.mortality.sgtin ? this.animalListItems.find(a => a.sgtin === this.mortality.sgtin) : undefined;
    this.selectedAnimalListItem = this.mortality.sgtin ? this.animalListItems.find((a) => a.sgtin === this.mortality.sgtin) : "";
    if (!this.selectedAnimalListItem) this.selectedAnimalListItem = "";

    if (this.mortality.diedInTransit !== undefined) {
      this.changed = true;
      this.diedInTransit = this.mortality.diedInTransit;
    }

    if (this.mortality.sgtin) {
      this.lockedDetails = true;
    }

    if (this.mortality.dispatchDestinationType !== undefined) {
      this.dispatchDestinationType = this.mortality.dispatchDestinationType;
    }

    // if (this.mortality.dispatchType !== undefined) {
    //   this.dispatchType = this.mortality.dispatchType;
    // }
    console.log("this.mortality.dispatchBatchGuid", this.mortality.dispatchBatchGuid);
    console.log("this.mortality.sgtin", this.mortality.sgtin);
    if (this.mortality.dispatchBatchGuid !== undefined) {
      await this.getDispatchBatches();
      this.selectedDispatchBatch = this.dispatchBatches.find((db) => db.guid === this.mortality.dispatchBatchGuid) ?? "";

      if (this.mortality.sgtin) {
        this.selectedAnimal = {
          sgtin: this.mortality?.sgtin ?? "",
          customFeeder: this.mortality.customFeeder as Models.CustomFeeder,
          breed: this.mortality?.breed ?? "",
          gender: this.mortality?.gender ?? "",
        };
      }
    }
  }

  determineTagColour() {
    this.tagColour = this.mortality.sgtin ? getTagColour(this.mortality.sgtin as string)?.name : "green";
  }

  @Watch("selectedKraalId")
  onSourceKraalIdChanged(selectedKraalId: any) {
    console.log("selectedKraalId: " + selectedKraalId);
    this.$store.commit("updateUserLocationField", { path: "mortality.sourceKraalId", value: selectedKraalId });
  }

  dateString: string = "";
  dateMenu: boolean = false;

  //animals: any[] = [];

  ////////
  // Ailments

  ailmentListItems: { guid: string; text: string }[] = [];
  selectedAilmentsListItems: ({ guid: string; text: string } | "")[] = [];
  getAilmentListItemsButtonState: ButtonState = "ready";
  getSelectedAilmentsButtonState: ButtonState = "ready";

  uiUpdate = 0;

  get modelSelectedAilmentsListItems(): ({ guid: string; text: string } | "")[] {
    return this.selectedAilmentsListItems;
  }

  set modelSelectedAilmentsListItems(selectedAilmentsListItems: ({ guid: string; text: string } | "")[]) {
    if (selectedAilmentsListItems === undefined) selectedAilmentsListItems = [];

    this.selectedAilmentsListItems = selectedAilmentsListItems;
    this.getAilmentsFromServer();
  }

  async getAilmentsFromServer() {
    if (!this.selectedAilmentsListItems.length) return;
    try {
      this.getSelectedAilmentsButtonState = "busy";
      const ailments = [];
      for (const selectedAilmentListItem of this.selectedAilmentsListItems)
        if (selectedAilmentListItem) ailments.push(await getItemFromServer("Ailment", selectedAilmentListItem.guid));

      this.ailmentChange(ailments);
      this.getSelectedAilmentsButtonState = "success";
    } catch (err) {
      this.getSelectedAilmentsButtonState = "error";
      console.error(err);
      this.ailmentChange([]);
    }
  }

  async getAilmentListItems() {
    try {
      this.getAilmentListItemsButtonState = "busy";
      this.ailmentListItems = [];
      let items = await listAilment(true);
      this.ailmentListItems = items.map((i: any) => ({ guid: i.guid, text: i.ailment }));
      this.getAilmentListItemsButtonState = "success";
    } catch (err) {
      console.error(err);
      this.getAilmentListItemsButtonState = "error";
    }

    //If selected is not found in list then add it
    for (const selectedAilment of this.selectedAilments) {
      if (selectedAilment && !this.ailmentListItems.find((t) => t.guid === (selectedAilment as Models.Ailment).guid)) {
        const a = selectedAilment as Models.Ailment;
        this.ailmentListItems.push({ guid: a.guid, text: a.ailment ?? "" });
      }
    }
  }

  //ailments: Models.Ailment[] = [];
  selectedAilments: Models.Ailment[] = [];
  ailmentChange(ailments: any) {
    //console.log(ailments);
    this.$store.commit("updateUserLocationField", { path: "mortality.ailments", value: ailments });
  }

  // Ailments
  ////////
  // Animals

  selectedAnimalListItem: any = "";
  //selectedAnimal: Models.Animal | "" = "";
  selectedAnimal:
    | {
        sgtin: string;
        customFeeder: Models.CustomFeeder;
        breed: string;
        gender: string;
      }
    | "" = "";
  refreshAnimalListItemsButtonState: ButtonState = "disabled";
  refreshAnimalListItemsErrorMessage: string = "";
  getAnimalErrorMessage: string = "";

  //this must be populated with animals from dispatch batch if "died in transit" is selected
  animalListItems: {
    typename: string;
    guid: string;
    sgtin?: string;
    owner?: string;
    breed?: string;
    gender?: string;
    tagId?: string;
    mass?: number;
  }[] = [];

  @Watch("selectedAnimal")
  onSelectedAnimalChanged(selectedAnimal: any) {
    console.log("onSelectedAnimalChanged selectedAnimal: " + JSON.stringify(selectedAnimal));
    let updateRequired = selectedAnimal?.sgtin !== this.mortality?.sgtin;
    this.$store.commit("updateUserLocationField", { path: "mortality.sgtin", value: selectedAnimal ? selectedAnimal.sgtin : undefined });
    if (updateRequired) {
      this.$store.commit("updateUserLocationField", { path: "mortality.customFeeder", value: selectedAnimal ? selectedAnimal.customFeeder : undefined });
      this.$store.commit("updateUserLocationField", { path: "mortality.breed", value: selectedAnimal ? selectedAnimal.breed : undefined });
      this.$store.commit("updateUserLocationField", { path: "mortality.gender", value: selectedAnimal ? selectedAnimal.gender : undefined });
    }
    this.uiUpdate++;
    this.determineTagColour();
    console.log("onSelectedAnimalChanged finished");
  }

  @Watch("selectedAnimalListItem")
  async onSelectedAnimalListItemChanged(selectedAnimalListItem: any) {
    console.log("onSelectedAnimalListItemChanged");
    console.dir(selectedAnimalListItem);

    if (selectedAnimalListItem) {
      try {
        this.selectedAnimal = "";
        this.getAnimalErrorMessage = "";
        if (!this.diedInTransit) {
          const a = await this.getAnimalFromServer();
          console.log("got animal from server");
          this.selectedAnimal = {
            sgtin: a.sgtin ?? "",
            customFeeder: a.customFeeder as Models.CustomFeeder,
            breed: a.breed ?? "",
            gender: a.gender ?? "",
          };
        } else {
          //throw Error("TODO: get custom feeder from dispatch batch when selected");
          if (!this.selectedDispatchBatchCustomFeeder) {
            throw Error("Could not get owner for selected animal");
          }
          this.selectedAnimal = {
            sgtin: this.selectedAnimalListItem?.sgtin ?? "",
            customFeeder: this.selectedDispatchBatchCustomFeeder,
            breed: this.selectedAnimalListItem?.breed ?? "",
            gender: this.selectedAnimalListItem?.gender ?? "",
          };
          this.mass = `${this.selectedAnimalListItem?.mass ?? ""}`;
        }
      } catch (err) {
        console.error("error getting animal from server:");
        console.error(err);
        this.getAnimalErrorMessage = (err as any)?.toString() ?? "no error message found";
      }
    } else this.selectedAnimal = "";
  }

  async getAnimalFromServer(): Promise<Models.Animal> {
    let json = await this.$store.dispatch(
      "graphQl",
      {
        gql: Models.gql.queries.getAnimal,
        variables: {
          guid: this.$store.state.user.location.guid,
          itemGuid: this.selectedAnimalListItem.guid,
        },
      },
      { root: true }
    );
    console.log("graphQL:");
    console.dir(json);

    return json.data.getAnimal as Models.Animal;
  }

  async refreshAnimalListItems() {
    try {
      this.refreshAnimalListItemsButtonState = "busy";
      this.refreshAnimalListItemsErrorMessage = "";

      this.animalListItems = [];

      if (this.animalListItemSearch?.length >= this.NUM_CHARS) {
        if (this.diedInTransit) {
          const owner = this.selectedDispatchBatch !== "" ? this.selectedDispatchBatch.ownerName : "";
          console.log("OWNER", owner);
          this.animalListItems = ((await this.getDispatchedAnimals()) ?? [])
            .filter((da) => !da.mortalityGuid) //filter out animals that already have a mortality recorded.
            .map((da) => ({
              typename: "Animal",
              guid: da.sgtin ?? "",
              sgtin: da.sgtin ?? "",
              owner: da.owner ? da.owner : owner,
              breed: da.breed ?? "",
              gender: da.gender ?? "",
              tagId: da.sgtin ? tagId(da.sgtin) : "",
              mass: da.dispatchMassIndividual,
            }));
        } else {
          this.animalListItems = await listAnimal(this.animalListItemSearch);
        }
        this.refreshAnimalListItemsButtonState = "success";
        return;
      } else {
        this.refreshAnimalListItemsButtonState = "disabled";
        this.animalListItems = [];
        return;
      }

      console.log("animalListItems", this.animalListItems);
    } catch (err) {
      this.animalListItems = [];
      console.error("refreshAnimalListItems() error:");
      console.error(err);
      this.refreshAnimalListItemsErrorMessage = (err as any)?.toString() ?? "no error message found";
      this.refreshAnimalListItemsButtonState = "error";
    }
  }

  async getDispatchedAnimals() {
    this.refreshAnimalListItemsButtonState = "busy";
    this.refreshAnimalListItemsErrorMessage = "";
    try {
      if (this.selectedDispatchBatch === "") return;
      const gql = `
        query dispatchedAnimals($guid: String!, $dispatchBatchGuid: String!, $dispatchBatchReference: String!, $type: String!) {
          dispatchedAnimals(
            guid: $guid,
            dispatchBatchGuid: $dispatchBatchGuid,
            dispatchBatchReference: $dispatchBatchReference,
            type: $type)
          {
            sgtin
            breed
            gender
            owner
            dispatchTime
            dispatchMassIndividual
            dispatchMassWeighbridge
            abattoirMassWeighbridge
            dispatchType
            dispatchReference
            referenceGuid
            mortalityGuid
          }
        }
      `;
      let json = await this.$store.dispatch(
        "graphQl",
        {
          gql: gql,
          variables: {
            guid: this.$store.state.user.location.guid,
            dispatchBatchGuid: this.selectedDispatchBatch.guid,
            dispatchBatchReference: this.selectedDispatchBatch.reference,
            type: this.dispatchDestinationType,
          },
        },
        { root: true }
      );
      //console.log("graphQL: " + JSON.stringify(json));
      //if (!json.data || !json.data.dispatchedAnimals) throw Error("No dispatchedAnimals returned.");
      let fromServerDispatchedAnimals: Models.DispatchedAnimal[] = json.data?.dispatchedAnimals ?? [];
      console.dir(fromServerDispatchedAnimals);
      this.refreshAnimalListItemsButtonState = "success";

      return fromServerDispatchedAnimals;
    } catch (err) {
      console.log("getDispatchedAnimals error: ", err);
      this.refreshAnimalListItemsButtonState = "error";
      this.refreshAnimalListItemsErrorMessage = `${err}`;
    }

    return [];
  }

  async scanTag() {
    let sgtin: string = await this.$store.dispatch("scanner/scanSgtin");
    if (sgtin.startsWith("ERROR")) {
      this.$store.commit("popup/displayOk", [sgtin]);
    } else {
      sgtin = sgtin.replace(/"/g, "");
      //get guid for animal from animal list
      let animalToFind = this.animalListItems.find((a) => a.sgtin === sgtin);
      if (animalToFind) {
        this.selectedAnimalListItem = animalToFind;
        await this.onSelectedAnimalListItemChanged(animalToFind);
      } else {
        //animal not found
        this.$store.commit("popup/displayOk", ["Animal not found"]);
      }
    }
  }

  // Animals
  ////////
  // Kraals

  kraalIds: string[] = [];
  getKraalsButtonState: ButtonState = "ready";

  async getKraals() {
    try {
      this.getKraalsButtonState = "busy";
      let json = await this.$store.dispatch(
        "graphQl",
        {
          gql: `query Kraals($guid: String!) {
          Kraals(guid: $guid) {
            kraalId
          }
        }`,
          variables: {
            guid: this.$store.state.user.location.guid,
          },
        },
        { root: true }
      );
      console.log("graphQL:");
      console.dir(json);
      this.kraalIds = json.data.Kraals.map((k: any) => k.kraalId);
      this.getKraalsButtonState = "success";
    } catch (err) {
      this.getKraalsButtonState = "error";
    }
  }

  // Kraals
  ////////

  get connectedToProxyButtonState() {
    if (this.$store.state.scanner.busyScanning) {
      this.getConnectedToProxyButtonState = "busy";
    } else if (this.$store.state.connectedToProxy) {
      this.getConnectedToProxyButtonState = "ready";
    } else {
      this.getConnectedToProxyButtonState = "disabled";
    }
    return this.getConnectedToProxyButtonState;
  }

  getConnectedToProxyButtonState: ButtonState = "error";

  get mortality(): Models.Mortality {
    return this.$store.getters["storage"]().mortality;
  }

  get moment() {
    return this.$store.state.moment;
  }

  rules = {
    validNumber: (value: string) => /^[0-9]*\.{0,1}[0-9]*$/.test(value) || "Invalid input.",
  };

  mass: string = "";
  massChange(mass: any) {
    this.mass = mass === undefined || mass === null ? "" : mass;
    console.log("mass: " + mass);
    //must check for true explicitly due to how rules works with bools and strings
    if (this.rules.validNumber(mass) !== true) {
      //console.log("invalid input: " + mass);
      this.$store.commit("updateUserLocationField", { path: "mortality.mass", value: undefined });
      return;
    }
    this.$store.commit("updateUserLocationField", { path: "mortality.mass", value: isNaN(parseFloat(mass)) ? undefined : parseFloat(mass) });
  }

  cost: string = "";
  costChange(cost: any) {
    this.cost = cost === undefined || cost === null ? "" : cost;
    //console.log("cost: " + cost);
    //must check for true explicitly due to how rules works with bools and strings
    if (this.rules.validNumber(cost) !== true) {
      //console.log("invalid input: " + cost);
      this.$store.commit("updateUserLocationField", { path: "mortality.cost", value: undefined });
      return;
    }
    this.$store.commit("updateUserLocationField", { path: "mortality.cost", value: isNaN(parseFloat(cost)) ? undefined : parseFloat(cost) });
  }

  notes = "";
  notesChange(notes: any) {
    this.notes = notes;
    this.$store.commit("updateUserLocationField", { path: "mortality.notes", value: [notes] });
  }

  save() {
    //TODO: data validation before saving
    //if (!this.selectedAnimal) {
    if (!this.mortality.sgtin) {
      this.$store.commit("popup/displayOk", [`Can not save. No Tag ID selected.`]);
      return;
    }

    //TODO: popup and block saving if another mortality with the same sgtin (different guid) is found

    this.$store.commit("popup/displayYesNo", {
      messages: ["Are you sure that you want to save?"],
      yesAction: async () => {
        try {
          this.$store.commit("popup/displayWait", ["Saving..."]);
          console.log(this.$store.getters["storage"]().mortality);
          let mortalityClone: Models.Mortality = lodash.cloneDeep(this.$store.getters["storage"]().mortality);
          mortalityClone.metadata = this.$store.getters["user/getUpstreamMetadata"]();
          if (!mortalityClone.app) {
            //might already be set to "field"
            mortalityClone.app = "office";
          }
          let json = await this.$store.dispatch(
            "graphQl",
            {
              gql: `mutation mortality($guid: String!, $mortality: MortalityInput!) {
                mortality(guid: $guid, mortality: $mortality) {
                  ...changeTrackingFields
                }
              }${changeTrackingComponentFragment}`,
              variables: {
                guid: this.$store.state.user.location.guid,
                mortality: mortalityClone as Models.Mortality,
              },
              timeout: 10 * 1000,
            },
            { root: true }
          );
          console.log("graphQL: " + JSON.stringify(json));
          let mortality = this.$store.getters["storage"]().mortality as Models.Mortality;
          mortality.changeTracking = json.data.mortality;

          if (mortality.diedInTransit && mortality.dispatchDestinationType && this.selectedDispatchBatch) {
            //load up dispatch batch
            //mortality.dispatchDestinationType
            //mortality.dispatchBatchGuid
            const typename = mortality.dispatchDestinationType === "abattoir" ? "DispatchToAbattoirBatch" : "DispatchToSiteBatch";
            const dispatchBatch: Models.DispatchToAbattoirBatch | Models.DispatchToSiteBatch = await getItemFromServer(
              typename,
              this.selectedDispatchBatch.guid
            );
            console.log("dispatchBatch.dispatchedAnimals", dispatchBatch.dispatchedAnimals);
            const dispatchedAnimal = dispatchBatch.dispatchedAnimals.find((da) => da.sgtin === mortality.sgtin);

            if (!dispatchedAnimal) {
              throw Error(`Could not find dispatched animal ${mortality.sgtin}`);
            }

            dispatchedAnimal.mortalityGuid = mortality.guid;
            console.log(`dispatchedAnimal.mortalityGuid = ${dispatchedAnimal.mortalityGuid}`);

            let gql: string;
            let variables: any;

            if (this.dispatchDestinationType === "abattoir") {
              gql = `mutation dispatchToAbattoirBatch($guid: String!, $dispatchToAbattoirBatch: DispatchToAbattoirBatchInput!) {
                            dispatchToAbattoirBatch(guid: $guid, dispatchToAbattoirBatch: $dispatchToAbattoirBatch) {
                              ...changeTrackingFields
                            }
                          }${changeTrackingComponentFragment}`;
              variables = { guid: this.$store.state.user.location.guid, dispatchToAbattoirBatch: dispatchBatch };
            } else {
              gql = `mutation setDispatchToSiteBatch($guid: String!, $dispatchToSiteBatch: DispatchToSiteBatchInput!) {
                            setDispatchToSiteBatch(guid: $guid, dispatchToSiteBatch: $dispatchToSiteBatch) {
                              ...changeTrackingFields
                            }
                          }${changeTrackingComponentFragment}`;
              variables = { guid: this.$store.state.user.location.guid, dispatchToSiteBatch: dispatchBatch };
            }

            let json = await this.$store.dispatch(
              "graphQl",
              {
                gql,
                variables,
                timeout: 10 * 1000,
              },
              { root: true }
            );
            console.log(`Dispatched animal updated on server.`);
            console.log("graphQL: " + JSON.stringify(json));
          }

          //await this.$store.dispatch("data/set", { objectStore: "Mortality", items: [lodash.cloneDeep(mortality)] });
          this.$router.push({ path: "list/mortalities" });
          this.$store.commit("popup/hide");
        } catch (err) {
          console.log(err);
          this.$store.commit("popup/hide");
          this.$store.commit("popup/displayOk", { messages: [`Error: ${err}`] });
        }
      },
    });
  }

  back() {
    this.$store.commit("popup/displayYesNo", {
      messages: ["Are you sure? Unsaved work will be lost."],
      yesAction: () => {
        this.$store.commit("updateUserLocationField", { path: "mortality", value: {} });
        this.$router.push({ path: "list/mortalities" });
      },
    });
  }

  tagIdFunc(sgtin: string) {
    return tagId(sgtin);
  }
}
